module.exports = __webpack_public_path__ + "static/media/scheme.836f17db.svg";